import celltherapy360Logo from 'assets/CT360-LOGO-RBG_CT360.png';
import bmsLogo from 'assets/bms_logo_rgb_pos_150.png';
import pluvictoLogo from 'assets/pluvicto_logo.png';
import lutatheraLogo from 'assets/lutathera-logo.png';
import novartisLogo from 'assets/Novartis_Logo_RGB.png';
import cizplamLogo from 'assets/Cizplam_logo.png';
import ventixalLogo from 'assets/ventixal_logo.png';
import uroliftLogo from 'assets/UROLIFT_2c_GoldO_BKTAG.png';
import teleflexLogo from 'assets/Teleflex_Logo_BK.png';
import teleflexLogoNavy from 'assets/Teleflex_Global_Corporate_Brand_Logo_CMYK_Navy.png';
import saphneloLogoRtm from 'assets/saphnelo-dosage-rtm-a360-logo.png';
import imjudoLogo from 'assets/imjudo-a360.png';
import aquablationLogo from 'assets/Aquablation_Logo_RGB_Lockup_150.png';
import proceptBioroboticsLogo from 'assets/PROCEPT_Logo_Solid_RGB_150.png';
import imfinziImjudoAccess360 from 'assets/imfinzi-imjudo-access360.png';
import fasenraLogo from 'assets/FASENRA_R_logo_exUS_RGB_Icon_Left.jpg';
import azLogoWhite from 'assets/astraZeneca.png';
import azLogo from 'assets/AZ-logo.png';
import silkRoadLogo from 'assets/SilkRoadMedical_Logo_KO_Orange_RGB.png';
import tcarLogo from 'assets/SRM_Less Invasive Standard Logo 5PF_2nd Jan 2024.png';
import wainuaLogo from 'assets/WAINUA_US_TM_Prom_RGB_FC_Pos.png';
import leqembiLogo from 'assets/logo-leqembi.png';
import eisaiLogo from 'assets/eisai.png';
import ilevroLogo from 'assets/ILV logo_white.png';
import harrowLogo from 'assets/Harrow_logo_Rev wTag wNewTM (1).png';
import spravatoLogo from 'assets/Spravato_logo_r_c3_color_rgb.png';
import jjLogo from 'assets/JJ_Logo_SingleLine_Red_RGB.png';
import nurtecLogo from 'assets/nurtec-logo.jpg';
import pfizerLogo from 'assets/pfizer-logo.png';
import pfizerWhiteLogo from 'assets/pfizer-white-logo.svg';
import pfizerDermatologyLogo from 'assets/Pfizer-Dermatology-Patient-Access-logo.png';
import zavzpretLogo from 'assets/Zavzpret_TM_RGB_Logo.jpg';
import zymfentraLogo from 'assets/Zymfentra_Logo_SC120mg_()_300.png';
import celltrionLogo from 'assets/celltrion_logo.svg';
import barrigelLogo from 'assets/Barrigel_Primary_Trademark Logo_RGB_4C.png';
import cibinqoLogo from 'assets/cibinqo-logo-transparent.png';
import litfuloLogo from 'assets/Litfulo_Logo_50mg_RM_KO_RGB.png';

const logoAssets = {
  // Abecma.
  'celltherapy360-logo.png': celltherapy360Logo,
  'bms-logo.png': bmsLogo,
  // Pluvicto & lutathera.
  'pluvicto_logo.png': pluvictoLogo,
  'lutathera-logo.png': lutatheraLogo,
  'novartis_logo.png': novartisLogo,
  // Cizplam Sales Demo site.
  'cizplam-logo.png' : cizplamLogo,
  // Ventixal Sales Demo site.
  'ventixal-logo.png' : ventixalLogo,
  // Urolift.
  'urolift-logo.png': uroliftLogo,
  // Astrazeneca Saphnelo NOC.
  'saphnelo-logo-rtm.png': saphneloLogoRtm,
  // Astrazeneca Imjudo NOC.
  'imjudo-logo.png': imjudoLogo,
  // Multiple AZ sites - Note: ALL AZ sites share this image.
  'az-logo.png': azLogo,
  'az-logo-white.png': azLogoWhite,
  // Fasenra.
  'fasenra-logo.png': fasenraLogo,
  // Aquablation
  'aquablation-logo.png': aquablationLogo,
  'procept-biorobotics-logo.png': proceptBioroboticsLogo,
  //Imfinzi + Imjudo
  'imfinzi-imjudo-access360.png': imfinziImjudoAccess360,
  //enroute
  'silk-road-logo.png': silkRoadLogo,
  'tcar-logo.png': tcarLogo,
  //wainua
  'wainua-logo.png': wainuaLogo,
  //leqembi
  'leqembi-logo.png': leqembiLogo,
  'eisai-logo.png': eisaiLogo,
  //harrow PAL
  'ilevro-logo.png': ilevroLogo,
  'harrow-logo.png': harrowLogo,
  //spravato
  'spravato-logo.png': spravatoLogo,
  'jj-logo.png': jjLogo,
  //pfizer
  'pfizer-logo.png': pfizerLogo,
  'pfizer-white-logo.png': pfizerWhiteLogo,
  'pfizer-dermatology-logo.png': pfizerDermatologyLogo,
  //zavzpret
  'zavzpret-logo.png': zavzpretLogo,
  //nurtec
  'nurtec-logo.jpg': nurtecLogo,
  //Celltrion.
  'celltron-logo.png': celltrionLogo,
  'zymfentra-logo.png': zymfentraLogo,
  //Barrigel
  'teleflex-logo.png': teleflexLogo,
  'teleflex-logo-navy.png': teleflexLogoNavy,
  'barrigel-logo.png': barrigelLogo,
  //Cibinqo.
  'cibinqo-logo.png': cibinqoLogo,
  //Litfulo.
  'litfulo-logo.png': litfuloLogo
};

export default logoAssets;
